import { Stack, Typography } from '@mui/material';
import React from 'react';
import { TemplatePreview } from './TemplatePreview';
import { RendererResult, Template } from '@ekkogmbh/apisdk';
import { ReactiveRow } from 'src/Common/Components/Stacks';

interface Props {
  template: Pick<Template, 'name' | 'coordinate' | 'type'>;
  rendererResult?: RendererResult;
  file?: File;
}

export default function TemplateCreateOverview({ template, file, rendererResult }: Props): React.JSX.Element {
  const overlineStyle = { fontWeight: 700 };
  const { name, coordinate, type } = template;

  const parsedFields = rendererResult?.fields ?? {};
  const parsedAnnos = rendererResult?.annotations ?? {};
  const parsedFieldKeys = Object.keys(parsedFields);
  const parsedAnnoKeys = Object.keys(parsedAnnos);

  return (
    <ReactiveRow>
      <Stack direction={'column'}>
        <Typography variant="overline" color={'primary'} style={overlineStyle}>
          Name
        </Typography>
        <Typography variant="h6" gutterBottom>
          {name}
        </Typography>
        <Typography variant="overline" color={'primary'} style={overlineStyle}>
          Coordinate
        </Typography>
        <Typography variant="h6" gutterBottom>
          {coordinate}
        </Typography>
        <Typography variant="overline" color={'primary'} style={overlineStyle}>
          Type
        </Typography>
        <Typography variant="h6" gutterBottom>
          {type}
        </Typography>
        {parsedFieldKeys.length > 0 && (
          <>
            <Typography variant="overline" color={'primary'} style={overlineStyle}>
              Field Keys
            </Typography>
            <Stack direction={'column'}>
              {parsedFieldKeys.map((key: string) => (
                <Stack direction={'row'} key={`template-field-${key}`}>
                  <Typography variant="h6" display={'inline'} gutterBottom>
                    {key}
                  </Typography>
                  <Typography color={'primary'} display={'inline'} style={{ margin: '4px' }}>
                    ({parsedFields[key]})
                  </Typography>
                </Stack>
              ))}
            </Stack>
          </>
        )}
        {parsedAnnoKeys.length > 0 && (
          <>
            <Typography variant="overline" color={'primary'} style={overlineStyle}>
              Annotation Keys
            </Typography>
            <Stack direction={'column'}>
              {parsedAnnoKeys.map((key: string) => (
                <Stack direction={'row'} key={`template-anno-${key}`}>
                  <Typography variant="h6" display={'inline'} gutterBottom>
                    {key}
                  </Typography>
                  <Typography color={'primary'} display={'inline'} style={{ margin: '4px' }}>
                    ({parsedAnnos[key]})
                  </Typography>
                </Stack>
              ))}
            </Stack>
          </>
        )}
      </Stack>
      <Stack direction={'column'}>
        {file && (
          <>
            <Typography variant="overline" color={'primary'} style={overlineStyle}>
              Filename
            </Typography>
            <Typography variant="h6" gutterBottom>
              {file.name}
            </Typography>
            <Typography variant="overline" color={'primary'} style={overlineStyle}>
              Filesize
            </Typography>
            <Typography variant="h6" gutterBottom>
              {Number(file.size / 1024).toFixed(2)} kB
            </Typography>
          </>
        )}
        {rendererResult && (
          <>
            <Typography variant="overline" color={'primary'} style={overlineStyle}>
              Render Preview
            </Typography>
            <TemplatePreview extended preRender={rendererResult} />
          </>
        )}
      </Stack>
    </ReactiveRow>
  );
}
